// Step 22 — buyer findings surface.
//
// Reuses the Step-19 `AIFindingCard` verbatim so every buyer-scoped
// finding looks the same as a risk/preparedness/contract finding
// elsewhere in the AI workspace. Findings are built by
// `buyerFindingsFromIntel` — no new logic, just a projection over
// data the backend already returned.

import AIFindingCard from "../intelligence/AIFindingCard";
import { AIEmpty, AISection } from "../AIPrimitives";
import { buyerFindingsFromIntel } from "./helpers";

export default function AIBuyerFindings({ intel, workspaceId }) {
  const findings = buyerFindingsFromIntel(intel);
  if (findings.length === 0) {
    return (
      <AISection title="Öppna poster & signaler">
        <AIEmpty
          title="Inga öppna frågor, invändningar eller krav registrerade"
          hint="Poster dyker upp här när ett köpar-svar analyseras."
        />
      </AISection>
    );
  }
  return (
    <AISection
      title="Öppna poster & signaler"
      right={
        <span className="qai-page-section-hint">
          {findings.length} post{findings.length === 1 ? "" : "er"}
        </span>
      }
    >
      <div className="qai-attention-queue">
        {findings.map((f) => (
          <AIFindingCard key={f.key} finding={f} workspaceId={workspaceId} />
        ))}
      </div>
    </AISection>
  );
}
